import React from 'react';
import { useLocation } from 'react-router-dom';
import { getLocaleFromPathname } from '../lib/locale';

export default function SkipToContent() {
    const en = getLocaleFromPathname(useLocation().pathname) === 'en-US';
    const focusContent = (event) => {
        const main = document.querySelector('main');
        if (!main) return;
        event.preventDefault();
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
        main.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    return <a className="zild-skip-content" href="#main-content" onClick={focusContent}>
        {en ? 'Skip to content' : 'Pular para o conteúdo'}
    </a>;
}
